import { createSelector } from 'reselect';
import { get } from 'lodash';
import { selectEquipments, equipmentConfig, selectEquipmentInOperation, selectEquipmentNotInOperation } from '../api/selectors/equipment';
import { sys } from 'typescript';

const systemsSelector = (state) => state.system;
const systemStatusesSelector = (state) => state.system.systemStatuses;

export const selectSystems = createSelector(systemStatusesSelector, (systems) => {
  return systems;
});

export const selectAllSystemTags = createSelector(
  equipmentConfig,
  (equipments) => {
    const systemTags = Object.keys(equipments).map((key) =>{
        const sysTag = equipments[key][0].systemTag;
        return sysTag;
    });
    return [...new Set(systemTags)];
  }
)

export const getSystemsListFromEquipment = createSelector(
  equipmentConfig,
  (equipments) => {
    if (!equipments) return [];
    const systemTags = Object.keys(equipments).map((key, index) => {
      const equipment = equipments[key];
      const systemTag =   equipment[0].systemTag;

      return systemTag;
    });

    return [...new Set(systemTags)]
  }
);

export const selectSystemsNotInOperation = createSelector(
  getSystemsListFromEquipment,
  systemStatusesSelector,
  (allSystemTags, systemStatuses) => {
    const configuredSystems = systemStatuses.filter((system) => {
      return allSystemTags.includes(system.systemTag);
    });

    const notInOpSystems = configuredSystems.filter((system) => system.status === 'not_running');
    return notInOpSystems;
  }
);

export const selectEquipmentNotInOperationFilteredBySystemsNotInOperation = createSelector(
  selectEquipmentNotInOperation,
  selectSystemsNotInOperation,
  (equipmentEno, systemTags) => {
    const sysTagsSet = new Set(systemTags.map((system) => system.systemTag));
    const filteredEquipment =  equipmentEno.filter((equipment) => !sysTagsSet.has(equipment.systemTag));
    return filteredEquipment;
  }
);


export const getSystems = createSelector(
  systemsSelector,
  systemStatusesSelector,
  ({ systemConfig, systemStatuses }) => {
    const mappedSystems = systemConfig.map((system) => {
      const systemStatus = systemStatuses.find((status) => status.systemTag === system.systemTag);
      return {
        ...system,
        status: systemStatus?.status || 'running',
      };
    });
    return mappedSystems;
  }
);

export const getSystemFilters = createSelector(systemsSelector, ({ systemFilters }) => {
  return systemFilters;
});

export const getSystemStatuses = createSelector(
  systemsSelector,
  systemStatusesSelector,
  ({ systemConfig, systemStatuses }) => {
    const systemConfigStatuses = systemConfig.map((system) => {
      // system status is 'running' by default
      let merge = {
        ...system,
        status: 'running',
        timestamp: '',
      };
      if (systemStatuses && systemStatuses.length > 0) {
        systemStatuses.forEach((sys) => {
          if (system.systemTag === sys.systemTag) {
            merge = {
              ...system,
              status: sys.status,
              timestamp: sys.changedDate,
            };
          }
        });
      }
      return merge;
    });
    return systemConfigStatuses;
  }
);
